import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import TrackingLink from 'Layout/NavBar/MegaMenu/Categories/TrackingLink';

export default function ActionLinks({ setMegaMenuTab }) {
  return (
    <ul className="CategoriesMegaMenu__linksContainer mb-4" role="menu">
      <li className="CategoriesMegaMenu__link">
        <TrackingLink to="/categories/action" id="categories-action" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="action-links.link.action" defaultMessage="Action" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/action-roguelike" id="categories-actionroguelike" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="action-links.link.action-roguelike" defaultMessage="Action Roguelike" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/fighting" id="categories-fighting" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="action-links.link.fighting" defaultMessage="Fighting" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/fps" id="categories-firstpersonshooter" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="action-links.link.fps" defaultMessage="First-Person Shooter" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/hack-and-slash" id="categories-hackandslash" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="action-links.link.hack-and-slash" defaultMessage="Hack and Slash" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/platformer" id="categories-platformer" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="action-links.link.platformer" defaultMessage="Platformer" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/third-person-shooter" id="categories-thirdpersonshooter" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="action-links.link.third-person-shooter" defaultMessage="Third Person Shooter" />
        </TrackingLink>
      </li>
    </ul>
  );
}

ActionLinks.propTypes = {
  setMegaMenuTab: PropTypes.func,
};

ActionLinks.defaultProps = {
  setMegaMenuTab: () => { },
};
